// removed by extract-text-webpack-plugin
module.exports = {"trendIcon":"segment-trendIcon--1Ej2n","status-ok":"segment-status-ok--1hZZo","status-warning":"segment-status-warning--shmNf","status-problem":"segment-status-problem--QS_bx","status-disconnected":"segment-status-disconnected--3Nn7R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/Details/Segment/segment.scss
// module id = TnwQ
// module chunks = 4